import { http } from "@/api/index";

/**
 * Solicita as configurações de sinais de eventos para um ativo.
 * @param {Number} monitoringElementId Id do elemento de monitoramento do ativo.
 * @returns Array com todas as configurações de sinais de eventos disponíveis.
 */
const GetByMonitoringElementId = function(monitoringElementId)
{
	return http.get(`/EventsSettings/${monitoringElementId}`);
};

export default { GetByMonitoringElementId };